module.exports = __webpack_public_path__ + "media/images/webpage/hotels/2086/plan4-1-ab05441d1a46b05e89c0fac11ae976a0.webp";